
export const PurchaseDomainFaqQuestions = [{
  headline: $localize`Wunschdomain gefunden`,
  description: $localize`Sie bekunden Ihr Interesse und übermitteln Ihr Angebot an den Inhaber per Formular mit "Anfrage senden".`,
}, {
  headline: $localize`Bezahlvorgang`,
  description: $localize`Nach der Einigung bezahlen Sie einfach per Paypal oder Überweisung. Dazu erhalten Sie eine ordnungsgemäße Rechnung mit Kaufvertrag.`,
}, {
  headline: $localize`Transfer der Domain`,
  description: $localize`Nach Zahlungseingang wird die Domain zu Ihren Provider per Transfer übertragen (via Auth-Code).`,
}, {
  headline: $localize`Loslegen!`,
  description: $localize`Ihre neue Domain können Sie für ein Projekt nutzen oder einfach auf Ihre bestehende Homepage weiterleiten!`,
}]
